module.exports = __webpack_public_path__ + "img/avatar_ico9.92672f9e.jpg";